import React from 'react'
import PropTypes from 'prop-types'

import { Motion } from 'Components/UI'

import map from 'lodash/map'

import Plate from './plate'
import { Container } from './styles'

function Plates({ technologies, invert, ...rest }) {
  return (
    <Container {...rest}>
      {map(technologies, entity => (
        <Motion key={entity}>
          <Plate invert={invert} technologyName={entity} />
        </Motion>
      ))}
    </Container>
  )
}

Plates.defaultProps = {
  columns: '1',
  invert: 0,
  technologies: [],
}

Plates.propTypes = {
  columns: PropTypes.string,
  invert: PropTypes.number,
  technologies: PropTypes.array,
}

export default Plates
